document.addEventListener('DOMContentLoaded', () => {
    const STORAGE_KEY = 'unnivi_wishlist';

    // 1. Initialize: Check state of all buttons on page load
    const updateButtons = () => {
        const wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        document.querySelectorAll('.favorite-toggle').forEach(btn => {
            const handle = btn.dataset.productHandle;
            if (wishlist.includes(handle)) {
                btn.classList.add('active');
                btn.querySelector('svg').style.fill = 'currentColor'; // Ensure fill visual
            } else {
                btn.classList.remove('active');
                btn.querySelector('svg').style.fill = 'none'; // Ensure empty visual
            }
        });
    };

    // 2. Handle Click
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.favorite-toggle');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation(); // Stop click from triggering product link

        const handle = btn.dataset.productHandle;
        let wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

        if (wishlist.includes(handle)) {
            // Remove
            wishlist = wishlist.filter(h => h !== handle);
            btn.classList.remove('active');
            btn.classList.remove('pulse'); // Remove anim class to reset it
        } else {
            // Add
            wishlist.push(handle);
            btn.classList.add('active');

            // Trigger Pulse Animation
            btn.classList.remove('pulse');
            void btn.offsetWidth; // trigger reflow
            btn.classList.add('pulse');
        }

        localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
        updateButtons(); // Sync all buttons for this product (e.g. if multiple views)
    });

    // Initial Run
    updateButtons();

    // Watch for dynamic content (Quick Add, Search Load, Infinite Scroll)
    const observer = new MutationObserver(updateButtons);
    observer.observe(document.body, { childList: true, subtree: true });
});
